var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumb-nav',{scopedSlots:_vm._u([{key:"firstMenu",fn:function(){return [_vm._v("数据统计")]},proxy:true},{key:"secondMenu",fn:function(){return [_vm._v("数据报表")]},proxy:true}])}),_c('el-card',[_c('div',{staticStyle:{"width":"750px","height":"400px"},attrs:{"id":"main"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }